
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { ProductGroup } from "@/types/product";

interface ProductInterestSectionProps {
  productGroups: ProductGroup[];
  selectedInterests: string[];
  onInterestChange: (id: string, checked: boolean) => void;
}

const ProductInterestSection = ({ 
  productGroups,
  selectedInterests,
  onInterestChange 
}: ProductInterestSectionProps) => {
  return (
    <div className="space-y-4">
      <h3 className="font-medium text-lg">Products of Interest</h3>
      <p className="text-sm text-muted-foreground mb-2">Please select the product categories you're interested in:</p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {productGroups.map((group) => (
          <div key={group.id} className="flex items-start space-x-2">
            <Checkbox 
              id={`interest-${group.id}`} 
              checked={selectedInterests.includes(group.id)}
              onCheckedChange={(checked) => 
                onInterestChange(group.id, checked === true)
              }
            />
            <Label 
              htmlFor={`interest-${group.id}`} 
              className="text-sm leading-tight cursor-pointer"
            >
              {group.name}
            </Label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductInterestSection;
